import type { ReactNode } from "react";
import type { QueryClient } from "@tanstack/react-query";
import { QueryClientProvider } from "@tanstack/react-query";
import { I18nProvider } from "@/components/i18n/I18nProvider";
import { AuthProvider } from "@/hooks/use-auth";
import { ErrorBoundary } from "@/components/common/ErrorBoundary";

type Language = "it" | "en" | "de" | "sl";

// Provider sempre attivi, condivisi da entry client (hydrateRoot) e server (renderToString).
export function AppProviders({
  client,
  initialLanguage,
  children,
}: {
  client: QueryClient;
  initialLanguage?: Language;
  children: ReactNode;
}) {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={client}>
        <I18nProvider initialLanguage={initialLanguage}>
          <AuthProvider>{children}</AuthProvider>
        </I18nProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
